import { useSelector } from 'react-redux'
import { Group } from '../../../../../../common/Group.type'
import { fullName } from '../../../../../../util/fullName'

import userRole from '../../../../../../config/userRole'
import { useProcessContactGroup } from '../../../../../../hooks/fetch/contactGroup/useProcessContactGroup'
import {
  selectLoggedInUser,
  selectRole,
} from '../../../../../../slices/authSlice'
import DeleteButton from '../../../../../UtilComponent/level_1/DeleteButton'
import EditButton from '../../../../../UtilComponent/level_1/EditButton'

type Props = {
  group: Group
  target: string
}

const GroupCard = (props: Props) => {
  const { group, target } = props

  const role = useSelector(selectRole)
  const loggedInUser = useSelector(selectLoggedInUser)

  const { deleContactGroup } = useProcessContactGroup()

  return (
    <>
      <div className="cluster">
        <div className="stack">
          <div>グループ名：{group.groupName}</div>
          {role === userRole['カンパニー管理者'] && (
            <div>管理者：{group.groupAdmin ? fullName(group.groupAdmin) : '名前なし'}</div>
          )}
          <div>
            メンバー：
            {group?.members.map((member) => (
              <span key={member.id} className="me-2">
                {fullName(member)}
              </span>
            ))}
          </div>
        </div>
        {target === 'contactGroup' &&
          (role === userRole['カンパニー管理者'] ||
            (role === userRole['一般ユーザー'] &&
              group.userId === loggedInUser.userId)) && (
            <div className="cluster me-3">
              <EditButton linkPath={`/groups/${group.id}`} />
              <DeleteButton
                id={group.id}
                name={group.groupName}
                removeAPIMethod={deleContactGroup}
              />
            </div>
          )}
      </div>
      <hr />
    </>
  )
}

export default GroupCard
